import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  fetchNotificationsInactive,
  createNotificationsInactive,
  updateNotificationsInactive,
  deleteNotificationsInactive,
} from "./thunks";
import type { InactiveNotificationTemplate } from "@/types/notifications";

interface NotificationsInactiveState {
  data: InactiveNotificationTemplate[] | null;
  loading: boolean;
  error: any | null;
}

const initialState: NotificationsInactiveState = {
  data: null,
  loading: false,
  error: null,
};

const NotificationsInactiveSlice = createSlice({
  name: "notificationsInactive",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchNotificationsInactive.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotificationsInactive.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload as any;
        if (Array.isArray(payload))
          state.data = payload as InactiveNotificationTemplate[];
        else if (payload && payload.data)
          state.data = payload.data as InactiveNotificationTemplate[];
        else
          state.data = payload
            ? ([payload] as InactiveNotificationTemplate[])
            : null;
      })
      .addCase(fetchNotificationsInactive.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error;
      })

      .addCase(createNotificationsInactive.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNotificationsInactive.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload as InactiveNotificationTemplate | null;
        if (payload) state.data = [payload, ...(state.data || [])];
        toast.success("Template criado");
      })
      .addCase(createNotificationsInactive.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error;
        toast.error("Falha ao criar template");
      })

      .addCase(updateNotificationsInactive.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateNotificationsInactive.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload as InactiveNotificationTemplate;
        state.data = (state.data || []).map((t) =>
          t.id === updated.id ? updated : t,
        );
        toast.success("Template atualizado");
      })
      .addCase(updateNotificationsInactive.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error;
        toast.error("Falha ao atualizar template");
      })

      .addCase(deleteNotificationsInactive.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteNotificationsInactive.fulfilled, (state, action) => {
        state.loading = false;
        const id = action.meta.arg as number as number;
        state.data = (state.data || []).filter((t) => t.id !== id);
        toast.info("Template excluído");
      })
      .addCase(deleteNotificationsInactive.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error;
        toast.error("Falha ao excluir template");
      }),
});

export default NotificationsInactiveSlice.reducer;
